import { render, staticRenderFns } from "./ReturnsAndRefundsPage.vue?vue&type=template&id=688eaeeb&"
import script from "./ReturnsAndRefundsPage.vue?vue&type=script&lang=js&"
export * from "./ReturnsAndRefundsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports